export const statusChipStyles =
  isActive =>
  ({ palette }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    paddingX: 1.25,
    paddingY: 0.5,
    borderRadius: 999,
    cursor: 'pointer',
    border: `1px solid ${isActive ? palette.primary.main : palette.divider}`,
    backgroundColor: isActive ? palette.primary.main : 'transparent',
    color: isActive ? palette.primary.contrastText : palette.text.primary,
    fontSize: 12,
    fontWeight: 600,
    userSelect: 'none',
  });
